import "core-js/modules/es.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['conversations', 'contacts', 'currentUser'],
  methods: {
    selectConversation: function selectConversation(conversation) {
      var otherUser = this.otherUser(conversation.users);
      this.$emit('select-conversation', otherUser, conversation.messages);
    },
    otherUser: function otherUser(users) {
      var _this = this;

      var otherUserId = users.find(function (x) {
        return x !== _this.currentUser.id;
      });
      return this.contacts.find(function (x) {
        return x.id === otherUserId;
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    this.selectConversation(this.conversations[0]);
  }
};